import commonVars from './_common';
const self = () => {
    return commonVars;
};
const spaceLight = {
    name: 'Space',
    self
};
export default spaceLight;
